import script from "./ArchivePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchivePage.vue?vue&type=script&setup=true&lang=ts"

import "./ArchivePage.vue?vue&type=style&index=0&id=04baed10&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04baed10"]])

export default __exports__